<template>
	<div class="ooef" :style="getStyle(node)">
		<template v-if="!isFetching">
			<template v-if="fields.length > 0">

				<!-- variation -->
				<div ref="variationField">
					<Variation
						v-if="productType === 'variable'"
						:node="node"
						:product="product"
						:isValid.sync="isMultipleVarianValid"
						@select-varian="setSelectedVarian"
					/>
				</div>

				<!-- contact -->
				<div ref="contactField">
					<Contact
						:node="node"
						:title="sectionTitle"
						:fields.sync="fields"
						:provinces="provinces"
						:isMultipleVarian="isMultipleVarian"
						@set-destination="onSelectDestination"
						@set-value="setContactValue"
					/>
					<dropship-fields
						:node="node"
						:checked.sync="isDropshipChecked"
						:name.sync="dropshipperName"
						:phone.sync="dropshipperPhone"
						v-if="isDropshipEnabled"
					/>
				</div>

				<!-- shipment -->
				<Shipment
					:node="node"
					:product="product"
					:origin="origin"
					:availableCouriers="couriers"
					:availableServices="services"
					:destination="destination"
					:weight="weight"
					:selectedPayment.sync="selectedPayment"
					:selectedCourier.sync="selectedCourier"
					:selectedService.sync="selectedService"
					:multipleVariation="selectedMultipleVariation"
					:isMultipleVariant="isMultipleVarian"
					:productType="productType"
					:contact.sync="contact"
					@select-courier="onSelectCourier"
					@select-service="onSelectService"
					v-if="isAutoShipping"
				/>

				<!-- Payment -->
				<Payment
					:node="node"
					:payments="payments"
					:paymentChannels="paymentChannels"
					:selectedPayment.sync="selectedPayment"
					@select="onSelectPayment"
				/>

				<!-- bump -->
				<Bump
					:node="node"
					v-if="bump !== null && bump.status"
					:bump="bump"
					v-model="isBumpChecked"
				/>

				<!-- summary -->
				<Summary
					:node="node"
					:username="username"
					:product="product"
					:name="productName"
					:price="price"
					:salePrice="salePrice"
					:shipping="selectedService"
					:weight="weight"
					:uniqueCode="uniqueCode"
					:contact.sync="contact"
					:productType="productType"
					:simpleVariation="selectedVariation"
					:multipleVariation="selectedMultipleVariation"
					:selectedPayment="selectedPayment"
					:productPrice="productPrice"
					:quantity="quantity"
					:shippingCost="shippingCost"
					:coupon="selectedCoupon"
					@set-uniquecode="onSetUniqueCodePrice"
				/>

				<Coupon
					:node="node"
					:product="product"
					:contact.sync="contact"
					:shipping="selectedService"
					:selectedPayment="selectedPayment"
					:simpleVariation="selectedVariation"
					:multipleVariation="selectedMultipleVariation"
					@set-coupon="onSetCoupon"
				/>

				<!-- action -->
				<div class="checkout-actions mt-4">
					<button
						type="submit"
						class="btn btn-block-lg btn-complete-order ooef-submit-order"
						:class="buyButtonBgColor"
					>
						<span class="submit-text">{{ buyButtonText }}</span>
						<span class="submit-loader hidden"></span>
						<svg aria-hidden="true" data-prefix="far" data-icon="arrow-alt-circle-right" class="submit-arrow icon svg-inline--fa fa-arrow-alt-circle-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm72 20v-40c0-6.6 5.4-12 12-12h116v-67c0-10.7 12.9-16 20.5-8.5l99 99c4.7 4.7 4.7 12.3 0 17l-99 99c-7.6 7.6-20.5 2.2-20.5-8.5v-67H140c-6.6 0-12-5.4-12-12z"></path></svg>
					</button>
				</div>

			</template>

			<!-- Empty form -->
			<div class="wrapper" v-else>
				Form Not Selected
			</div>
		</template>
		<div class="m-3 p-3 text-center" v-else>
			<div class="is-loading large dark"></div>
		</div>
	</div>
</template>

<script>
import funnelFormApi from '@/api/funnel-form';
import {
	getAxiosErrorMessage,
	validatePhone,
	// scrollToElem,
	getOS,
	getBrowser,
	getDeviceType,
	safeTagsReplace,
	phoneNumberFormatting,
	setProductVariationName,
	getCODCost,
	formattedMultipleVariantAttributeName,
	getNodeStyle,
	// createAxiosClientNoAuth,
} from '@/lib/helper';
import DropshipFields from '@/components/funnels/pagebuilder/form/DropshipFields.vue';
import Summary from './Summary.vue';
import Shipment from './Shipment.vue';
import Payment from './Payment.vue';
import Variation from './Variation.vue';
import Contact from './Contact.vue';
import Coupon from './Coupon.vue';
import Bump from './Bump.vue';

export default {
	name: 'FormWrapper',
	props: ['node', 'previewDevice'],
	components: {
		// Field,
		Summary,
		Shipment,
		Payment,
		Variation,
		Contact,
		Coupon,
		Bump,
		DropshipFields,
	},
	data() {
		return {
			isSubmitting: false,
			isLoading: false,
			isCitiesFetching: false,
			isSubdistrictFetching: true,
			username: '',
			product: null,
			provinces: [],
			fields: [],
			sectionTitle: null,
			contact: {
				name: '',
				phone: '',
				quantity: 1,
			},

			// shipment
			origin: null,
			weight: 0,
			destination: null,
			couriers: [],
			services: [],
			selectedCourier: null,
			selectedService: null,
			completeDistricts: [],

			// payments
			payments: [],
			paymentChannels: [],
			selectedPayment: null,

			// product
			productName: '',
			price: '',
			uniqueCode: null,
			uniqueCodePrice: 0,
			productType: 'simple',

			selectedVariation: null,
			selectedMultipleVariation: [],
			isMultipleVarianValid: true,

			selectedCoupon: null,
			isBumpChecked: false,
			bump: null,

			isDropshipChecked: false,
			dropshipperName: '',
			dropshipperPhone: '',

			isFetching: false,
			isFetchingProvinces: false,
		};
	},
	computed: {
		variantAttributes() {
			let attributes = [];
			if (this.product !== null && this.product.variations && this.product.variations.attributes) {
				attributes = this.product.variations.attributes;
			}
			return attributes;
		},
		isMultipleVarian() {
			let varian = false;
			if (this.product !== null && this.product.variations.multiple_variations) {
				varian = this.product.variations.multiple_variations.enabled;
			}
			return varian;
		},
		buyButtonText() {
			let text = 'Buy Now';
			if (this.product !== null && this.product.form.elements.buy_button.text) {
				text = this.product.form.elements.buy_button.text;
			}
			return text;
		},
		buyButtonBgColor() {
			let background = 'Buy Now';
			if (this.product !== null && this.product.form.elements.buy_button.background) {
				background = this.product.form.elements.buy_button.background;
			}
			return background;
		},
		quantity() {
			let qty = 0;
			// variable with multiple
			if (this.productType === 'variable' && this.isMultipleVariant) {
				// eslint-disable-next-line
				qty = this.multipleVariation.reduce((totalQty, item) => {
					return totalQty + item.quantity;
				}, 0);

			// simple or variable (not multiple)
			} else if ((this.productType === 'simple') || (this.productType === 'variable' && !this.isMultipleVariant)) {
				// eslint-disable-next-line
				if (this.contact !== null && this.contact.quantity) {
					qty = this.contact.quantity;
				}
			}
			return qty;
		},
		shippingCost() {
			let cost = 0;
			if (this.selectedService !== null && this.selectedService.cost && this.selectedService.cost.length > 0) {
				cost = this.selectedService.cost[0].value;
			}
			return cost;
		},
		productPrice() {
			let price = 0;
			if (this.productType === 'variable') {
				if (this.selectedVariation !== null) {
					const name = setProductVariationName(this.selectedVariation);
					const product = this.product;
					if (product !== null) {
						const prices = product.variations.prices || [];
						const variation = prices.find(curr => curr.name === name);
						const firstVariationPrice = prices[0] ? prices[0].price : 0;
						price = variation ? variation.price : firstVariationPrice;
						// eslint-disable-next-line
						price = price * this.quantity;
					}
				}
			} else {
				price = parseInt(this.product?.price);
				// eslint-disable-next-line
				price = price * this.quantity;
			}
			return price;
		},
		orderMeta() {
			const currentUrl = window.location.host;
			const metaData = {
				url: currentUrl,
				ip: '',
				os: getOS(),
				browser: getBrowser(),
				location: '',
				network: '',
				device_type: getDeviceType(),
				device_model: '',
				user_agent: navigator.userAgent,
				embed: false,
				referrer: document.referrer ? document.referrer : '',
			};
			return metaData;
		},
		customerData() {
			// const product = this.product;
			const contact = this.contact;
			const phone = contact !== null && contact.phone
				? phoneNumberFormatting(contact.phone)
				: '';
			const email = contact !== null && contact.email
				? contact.email
				: '';
			const address = contact !== null && contact.address
				? safeTagsReplace(contact.address)
				: '';

			let provinceName = '';
			let provinceId = 0;
			if (contact !== null && contact.province) {
				provinceId = contact.province.id;
				provinceName = safeTagsReplace(contact.province.text);
			} else if (contact !== null && contact.complete_district) {
				provinceId = contact.complete_district.province_id;
				provinceName = contact.complete_district.province_name;
			}

			let cityName = '';
			let cityId = 0;
			if (contact !== null && contact.city) {
				cityId = contact.city.city_id;
				cityName = safeTagsReplace(contact.city.city_name_with_type);
			} else if (contact !== null && contact.complete_district) {
				cityId = contact.complete_district.city_id;
				cityName = contact.complete_district.city_name_with_type;
			}

			let districtName = '';
			let districtId = 0;
			let zip = 0;
			if (contact !== null && contact.district) {
				districtId = contact.district.subdistrict_id;
				districtName = safeTagsReplace(contact.district.subdistrict_name);
				zip = contact.district.zip;
			} else if (contact !== null && contact.complete_district) {
				districtId = contact.complete_district.subdistrict_id;
				districtName = contact.complete_district.subdistrict_name;
				zip = contact.complete_district.zip;
			}

			const params = {
				name: contact.name,
				phone,
				email,
				notes: '',
				address,
				quantity: this.quantity,
				state: provinceName,
				province_id: provinceId,
				province_name: provinceName,
				city: cityName,
				city_id: cityId,
				city_name: cityName,
				district: districtName,
				subdistrict_id: districtId,
				subdistrict_name: districtName,
				zip,
			};

			if (this.quantity !== 0) {
				params.quantity = this.quantity;
			} else {
				params.quantity = 1;
			}

			if (this.productType === 'variable') {
				if (this.isMultipleVarian) {
					const variations = this.selectedMultipleVariation.filter(curr => curr.quantity > 0);
					const variation = variations[0].variant.label;
					// eslint-disable-next-line
					const formmatedVariations = variations.map((curr) => {
						return {
							name: curr.variant.label.replace(/ - /g, '||'),
							quantity: curr.quantity,
							weight: curr.variant.weight,
							price: curr.variant.price,
							value: curr.variant.label_with_attribute_name,
						};
					});
					params.variation = variation.replace(/ - /g, '||');
					params.variations = formmatedVariations;
				} else {
					const selectedVariation = setProductVariationName(this.selectedVariation);
					const variation = formattedMultipleVariantAttributeName(this.variantAttributes, selectedVariation);
					params.variation = variation;
				}
			}

			return params;
		},
		shippingData() {
			const shipping = this.selectedService;
			const courier = this.selectedCourier;
			const service = shipping.service;
			const cost = shipping.cost[0].value;
			const cod = this.selectedPayment !== null && this.selectedPayment.key === 'cod';
			const shippingConfig = this.product?.shipping;
			const shippingCOD = shippingConfig.cod;
			const codCost = cod
				? getCODCost(shippingCOD, this.productPrice, this.shippingCost)
				: 0;

			const data = {
				courier: courier.code,
				service,
				cost,
				cod,
				cod_cost: codCost,
				cod_include_shipping: shippingCOD?.includeShipping,
				cod_fee_type: shippingCOD.feeType,
				cod_min: shippingCOD.minimal,
				cod_max: shippingCOD.maximal,
				cod_percentage: shippingCOD.percentage,
				markup: shippingConfig.markup,
				original_cost: cost,
			};
			return data;
		},
		paymentData() {
			const payment = this.selectedPayment;
			const data = {
				method: payment.method,
				data: {},
				channels: [],
			};

			if (payment.method === 'instant') {
				data.channels = [payment.key];
			}
			return data;
		},
		isDropshipEnabled() {
			// eslint-disable-next-line
			return this?.product?.form?.elements?.dropship_enabled;
		},
		formId() {
			return this?.node?.options?.formId ?? '';
		},
		isShippingEnabled() {
			const isEnabled = this?.product?.shipping?.enabled ?? false;
			return isEnabled;
		},
		isFlatShipping() {
			// eslint-disable-next-line
			const isFlat = this?.product?.shipping?.flat_shipping ?? false;
			return isFlat;
		},
		isFreeShipping() {
			// eslint-disable-next-line
			const isFree = this?.product?.shipping?.free_shipping ?? false;
			return isFree;
		},
		isAutoShipping() {
			const isAuto = this.isShippingEnabled && !this.isFlatShipping && !this.isFreeShipping;
			return isAuto;
		},
	},
	watch: {
		selectedMultipleVariation: {
			deep: true,
			handler() {
				const isMultipleVarianValid = this.selectedMultipleVariation.filter(curr => curr.quantity > 0).length > 0;
				this.isMultipleVarianValid = isMultipleVarianValid;
			},
		},
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.fetchForm();
		},

		getIpAddress() {
			// https://public.orderonline.id/ip
			// response {"ip":"139.228.193.36"}
		},

		fetchForm() {
			const formData = this.node && this.node.options ? this.node.options : null;

			if (formData !== null) {
				let productId = formData.productId;
				const product = formData.selectedProduct ? formData.selectedProduct : false;
				if (product && typeof product._id === 'object') {
					productId = product._id.$oid;
				}
				// this.username = formData.username;
				// const params = {
				// 	username: formData.username,
				// 	slug: product.slug,
				// };

				if (productId) {
					this.isFetching = true;
					const params = {};
					if (this.formId && this.formId !== '' && this.formId !== 0) {
						params.form_id = this.formId;
					}
					const callback = (response) => {
						const { data } = response;
						if (data && data !== undefined) {
							this.setProduct(data);
						}
						this.isFetching = false;
					};
					const errorCallback = (e) => {
						const message = getAxiosErrorMessage(e);
						console.log('message: ', message);
						this.isFetching = false;
					};

					// const publicApiUrl = process.env.VUE_APP_PUBLIC_URL || 'https://public.orderonline.id/api';
					// const client = createAxiosClientNoAuth(publicApiUrl);

					// funnelFormApi.getData(params, callback, errorCallback, client);
					funnelFormApi.getPublicProduct(productId, params, callback, errorCallback);
				}
			}
		},

		setProduct(product) {
			this.product = product;
			// eslint-disable-next-line
			this.sectionTitle = product?.form?.elements?.section_titles;
			this.weight = product?.weight;
			this.origin = product?.shipping?.origin;
			this.couriers = product?.shipping?.couriers ?? [];
			this.services = product?.shipping?.services ?? [];
			this.productType = product?.type;
			this.bump = product?.bump;

			// payment
			this.payments = product?.payments ?? [];
			// eslint-disable-next-line
			this.paymentChannels = product?.payment_channels ?? [];

			// product
			this.productName = product?.name ?? '';
			this.price = product?.price;
			// eslint-disable-next-line
			this.salePrice = product?.sale_price;
			// eslint-disable-next-line
			this.uniqueCode = product?.unique_code_price;

			const fields = product?.form?.elements?.fields ?? [];

			this.setFormFields(fields);
			// this.setProvinces(data);
		},

		// setProvinces(data) {
		// 	if (data.provinces) {
		// 		this.provinces = data.provinces;
		// 	}
		// },

		// eslint-disable-next-line
		setFormFields(fields) {
			const mapper = (curr) => {
				curr.is_valid = true;
				return curr;
			};
			let formattedFields = fields.map(mapper);

			// remove field quantity at type variable & multiple varian
			if (this.productType === 'variable' && this.isMultipleVarian) {
				formattedFields = formattedFields.filter(curr => curr.name !== 'quantity');
			}

			const isHasProvince = formattedFields.findIndex(({ name }) => name === 'province') !== -1;
			if (isHasProvince) {
				this.fetchProvinces();
			}

			this.fields = formattedFields;
		},

		fetchProvinces() {
			this.isFetchingProvinces = true;
			const params = {};
			const callback = (response) => {
				const provinces = response;
				this.provinces = provinces;
				this.isFetchingProvinces = false;
			};
			const errorCallback = () => {
				this.isFetchingProvinces = false;
			};
			funnelFormApi.getProvinces(params, callback, errorCallback);
		},

		onSelectCourier(courier) {
			this.selectedCourier = courier;
		},

		onSelectService(service) {
			this.selectedService = service;
		},

		onSelectPayment(payment) {
			this.selectedPayment = payment;
		},

		onSelectDestination(value) {
			this.destination = value;
		},

		setContactValue(value) {
			this.contact = value;

			// revalidate field
			// get key name as fields
			const fields = Object.keys(value);
			// loop fields to set is valid true
			for (let index = 0; index < fields.length; index++) {
				const name = fields[index];
				// check field is in array
				const nameIndex = this.fields.findIndex(curr => curr.name === name);
				if (nameIndex !== -1) {
					const field = this.fields[nameIndex];
					// check field that name not empty
					if (this.contact[name] !== '' || this.contact[name] !== null) {
						field.is_valid = true;
					}

					// validate phone
					if (name === 'phone') {
						const phoneValid = validatePhone(this.contact.phone);
						if (phoneValid) {
							field.is_valid = true;
						} else {
							field.is_valid = false;
						}
					}

					this.$set(this.fields, nameIndex, field);
				}
			}
		},

		setSelectedVarian(type, value) {
			if (type === 'multiple') {
				this.selectedMultipleVariation = value;
				// console.log('this.selectedMultipleVariation: ', this.selectedMultipleVariation);
			} else {
				this.selectedVariation = value;
			}
		},

		onSetCoupon(value) {
			this.selectedCoupon = value;
		},

		onSetUniqueCodePrice(value) {
			this.uniqueCodePrice = value;
		},

		getStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'margin',
				'padding',
				'bg-color',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
	},
};
</script>
